<template>
  <div class="searchfield input-group">
    <input
      v-click-outside="clickOutside"
      name="q"
      :id="idString + 'Field'"
      class="form-control"
      type="text"
      :placeholder="texts.placeholder"
      :aria-label="texts.sokfalt"
      v-model="query"
      autocomplete="off"
      ref="searchinput"
      @input="onInput"
      @keydown.down.prevent="onArrowDown"
      @keydown.up.prevent="onArrowUp"
    />
    <button
      :id="idString + 'ClearBtn'"
      type="button"
      :class="[this.showClearBtn ? '' : 'd-none', 'btn-reset']"
      @click="clearInput"
    >
      <Icon :type="useEntypoIcons ? 'cross' : 'fa-xmark'"></Icon>
      <span class="visually-hidden">{{ texts.taBortText }}</span>
    </button>
    <button
      ref="submitsearch"
      :id="idString + 'Button'"
      type="submit"
      class="btn-search"
      @click="onSearchButtonClick"
    >
      <Icon
        v-if="!showAnswer"
        :type="useEntypoIcons ? 'search' : 'fa-magnifying-glass'"
      ></Icon>
      <span v-if="showAnswer" class="searchText">{{ texts.skicka }}</span>
      <span v-else class="searchText">{{ texts.sok }}</span>
    </button>
  </div>
  <AutoComplete
    :autoCompleteItems="autoCompleteItems"
    :query="query"
    :event="event"
    :texts="texts"
    @currentSuggestion="setCurrentSuggestion"
  ></AutoComplete>
</template>

<script>
import clickOutside from "../../plugins/clickOutside";
import sitesearchservice from "../../plugins/sitesearchservice";
import Icon from "../../image/icon.vue";
import AutoComplete from "../../autocomplete/autocomplete.vue";

export default {
  name: "SearchInput",
  emits: ["searchSubmitted"],
  directives: {
    clickOutside,
  },
  props: {
    baseApiUrl: String,
    texts: Object,
    suggestSokOptions: Object,
    idString: String,
    searchPage: String,
    showAnswer: {
      type: Boolean,
      default: false,
    },
    useEntypoIcons: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      query: "",
      inputText: "",
      showClearBtn: false,
      autoCompleteItems: undefined,
      event: undefined,
      shouldDoAjax: false,
    };
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search);
    if (this.suggestSokOptions.Query.length > 0 && urlParams.has("q")) {
      this.query = urlParams.get("q");
    }

    if (this.query.length > 0) {
      this.showClearBtn = true;
    }
  },
  mounted() {
    this.updateShouldDoAjax();
  },
  watch: {
    baseApiUrl: 'updateShouldDoAjax',
    searchPage: 'updateShouldDoAjax',
  },
  components: {
    Icon,
    AutoComplete,
  },
  methods: {
    clearInput() {
      this.query = "";
      this.autoCompleteItems = [];
      this.showClearBtn = false;
      this.$refs.searchinput.focus();
    },
    onInput() {
      this.inputText = this.query;
      if (this.query.length == 0) {
        this.clearInput();
      } else if (this.query.length > 0) {
        this.showClearBtn = true;
        if (this.query.length >= 1) {
          this.getSuggestions();
        } else {
          this.autoCompleteItems = [];
        }
      }
    },
    onArrowDown($event) {
      this.event = $event;
    },
    onArrowUp($event) {
      this.event = $event;
    },
    setCurrentSuggestion(suggestion, click) {
      if (suggestion == "") {
        this.query = this.inputText;
      } else {
        this.query = suggestion;
      }
      if (click) {
        this.submitForm();
      }
    },
    getSuggestions() {
      sitesearchservice
        .getSuggestions(this.baseApiUrl, this.query, this.suggestSokOptions)
        .then((result) => {
          if (result && result.status === 200) {
            if (this.query.length >= 1) {
              this.autoCompleteItems = result.data;
            } else {
              this.autoCompleteItems = [];
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    submitForm() {
      setTimeout(() => this.$refs.submitsearch.click(), 50);
    },
    clickOutside() {
      this.autoCompleteItems = [];
    },
    onSubmitSearch(e) {
      // Hämta nuvarande URL-parametrar
      const urlParams = new URLSearchParams(window.location.search);
      // Uppdatera sökfrågan (q-parametern)
      urlParams.set("q", this.query);
      // Stäng autocomplete-förslag
      this.autoCompleteItems = [];
      // Skicka event till förälder (SiteSearch)
      this.$emit("searchSubmitted", urlParams);
      // Uppdatera URL:en i adressfältet
      history.replaceState(null, null, "?" + urlParams.toString());
    },
    updateShouldDoAjax() {
      // Om searchPage är tom eller null, använd AJAX (samma sida)
      let searchPagePath = this.searchPage;
      let currentPath = window.location.pathname;
      if (!searchPagePath) {
        this.shouldDoAjax = true;
      } else {
        this.shouldDoAjax = searchPagePath === currentPath;
      }
    },
    onSearchButtonClick(e) {
      if (this.shouldDoAjax) {
        e.preventDefault();
        this.onSubmitSearch(e);
      }
      // Annars klassisk submit (type=submit) sker automatiskt
    },
  },
};
</script>
